export const ArrowSolidIcon = `${process.env.REACT_APP_GCM_BUCKET_URL}/mythic-portal-v2/img/svg/arrow_solid.svg`;
export const LockIconDisabled = `${process.env.REACT_APP_GCM_BUCKET_URL}/mythic-portal-v2/img/svg/lock-disabled.svg`;
export const PostAddIcon = `${process.env.REACT_APP_GCM_BUCKET_URL}/mythic-portal-v2/img/svg/post_add.svg`;
export const LockIcon = `${process.env.REACT_APP_GCM_BUCKET_URL}/mythic-portal-v2/img/svg/lock-white.svg`;
